<template>
  <div class="rating">
    <div class="bars">
      <span class="bar filled"></span>
      <span class="bar" :class="{'filled': rating >= 3}"></span>
      <span class="bar" :class="{'filled': rating >= 3}"></span>
      <span class="bar" :class="{'filled': rating === 5}"></span>
      <span class="bar" :class="{'filled': rating === 5}"></span>
    </div>
    <p class="label" v-if="label">{{ label }}</p>
  </div>
</template>

<script>
export default {
  props: ['rating', 'label']
}
</script>

<style lang="scss">
  .rating{
    .label{
      color: $color-dark-green;
    }
    p{
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      letter-spacing: 1px;
    }
  }
  .bars{
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
    .bar{
      margin: 0 2.5px;
      display: block;
      background: #C0C5B0;
      width: 25px;
      height: 6px;
      border-radius: 3px;
      &.filled{
        background: $color-neon-green;
      }
    }
  }
</style>
